import { render, staticRenderFns } from "./FullPageMessage.vue?vue&type=template&id=332496fc&"
import script from "./FullPageMessage.vue?vue&type=script&lang=ts&"
export * from "./FullPageMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports